module.exports = __webpack_public_path__ + "img/icon-tri-viewresult.4ffea00e.png";